import e from "@emotion/styled/base";
import { Stack as t } from "../../Stack/index.js";
function o() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const b = /* @__PURE__ */ e(t, process.env.NODE_ENV === "production" ? {
  target: "e100i7ac0"
} : {
  target: "e100i7ac0",
  label: "OuterPreviewContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "o0rbfw",
  styles: "max-height:300px;overflow:auto;white-space:normal;word-break:break-word"
} : {
  name: "o0rbfw",
  styles: "max-height:300px;overflow:auto;white-space:normal;word-break:break-word/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvRHJvcHpvbmUvT3V0ZXJQcmV2aWV3L091dGVyUHJldmlldy5zdHlsZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXdFIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvRHJvcHpvbmUvT3V0ZXJQcmV2aWV3L091dGVyUHJldmlldy5zdHlsZWQudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkLCB7IFN0eWxlZENvbXBvbmVudCB9IGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IFN0YWNrIH0gZnJvbSAnLi4vLi4vU3RhY2snO1xuXG5leHBvcnQgY29uc3QgT3V0ZXJQcmV2aWV3Q29udGFpbmVyOiBTdHlsZWRDb21wb25lbnQ8YW55PiA9IHN0eWxlZChTdGFjaylgXG4gICAgbWF4LWhlaWdodDogMzAwcHg7XG4gICAgb3ZlcmZsb3c6IGF1dG87XG5cbiAgICB3aGl0ZS1zcGFjZTogbm9ybWFsO1xuICAgIHdvcmQtYnJlYWs6IGJyZWFrLXdvcmQ7XG5gO1xuIl19 */",
  toString: o
});
export {
  b as OuterPreviewContainer
};
